/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAudits200ResponseMeta } from './GetAudits200ResponseMeta';
import {
    GetAudits200ResponseMetaFromJSON,
    GetAudits200ResponseMetaFromJSONTyped,
    GetAudits200ResponseMetaToJSON,
    GetAudits200ResponseMetaToJSONTyped,
} from './GetAudits200ResponseMeta';
import type { GetAudits200ResponseLinks } from './GetAudits200ResponseLinks';
import {
    GetAudits200ResponseLinksFromJSON,
    GetAudits200ResponseLinksFromJSONTyped,
    GetAudits200ResponseLinksToJSON,
    GetAudits200ResponseLinksToJSONTyped,
} from './GetAudits200ResponseLinks';
import type { Client } from './Client';
import {
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
    ClientToJSONTyped,
} from './Client';

/**
 * 
 * @export
 * @interface GetClients200Response
 */
export interface GetClients200Response {
    /**
     * 
     * @type {Array<Client>}
     * @memberof GetClients200Response
     */
    data: Array<Client>;
    /**
     * 
     * @type {GetAudits200ResponseLinks}
     * @memberof GetClients200Response
     */
    links: GetAudits200ResponseLinks;
    /**
     * 
     * @type {GetAudits200ResponseMeta}
     * @memberof GetClients200Response
     */
    meta: GetAudits200ResponseMeta;
}

/**
 * Check if a given object implements the GetClients200Response interface.
 */
export function instanceOfGetClients200Response(value: object): value is GetClients200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('links' in value) || value['links'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function GetClients200ResponseFromJSON(json: any): GetClients200Response {
    return GetClients200ResponseFromJSONTyped(json, false);
}

export function GetClients200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClients200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ClientFromJSON)),
        'links': GetAudits200ResponseLinksFromJSON(json['links']),
        'meta': GetAudits200ResponseMetaFromJSON(json['meta']),
    };
}

export function GetClients200ResponseToJSON(json: any): GetClients200Response {
    return GetClients200ResponseToJSONTyped(json, false);
}

export function GetClients200ResponseToJSONTyped(value?: GetClients200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ClientToJSON)),
        'links': GetAudits200ResponseLinksToJSON(value['links']),
        'meta': GetAudits200ResponseMetaToJSON(value['meta']),
    };
}

